/* unplugin-vue-components disabled */import script from "./EditorClipPath.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorClipPath.vue?vue&type=script&setup=true&lang=js"

import "./EditorClipPath.vue?vue&type=style&index=0&id=f5eabacc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5eabacc"]])

export default __exports__